import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { db } from '../../firebaseConfig';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { Box, Button, Typography, Container } from '@mui/material';

const Payment = () => {
  const { userId, prodId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const userData = JSON.parse(localStorage.getItem("user") || null);
  const [product, setProduct] = useState({});
  const [paymentStatus, setPaymentStatus] = useState('pending');
  const [buyerPaid, setBuyerPaid] = useState(false);
  const [sellerConfirmed, setSellerConfirmed] = useState(false);

  useEffect(() => {
    const orderId = `${prodId}${userId}`;
    const orderRef = doc(db, 'order', orderId);
    getDoc(orderRef).then((doc) => {
      if (doc.exists()) {
        const data = doc.data();
        setProduct(data);
        setBuyerPaid(data.buyerPaid || false);
        setSellerConfirmed(data.sellerConfirmed || false);
      }
    });
  }, [userId, prodId]);

  const handleBuyerPaymentCompleted = async () => {
    const orderId = `${prodId}${userId}`;
    const orderRef = doc(db, 'order', orderId);
    await setDoc(orderRef, { buyerPaid: true }, { merge: true });
    setBuyerPaid(true);
  };

  const handleSellerPaymentReceived = async () => {
    const orderId = `${prodId}${userId}`;
    const orderRef = doc(db, 'order', orderId);
    await setDoc(orderRef, { sellerConfirmed: true, paymentStatus: 'completed' }, { merge: true });
    setSellerConfirmed(true);
    setPaymentStatus('completed');
    navigate(`/store/${userId}`);
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Box 
        sx={{ 
          backgroundColor: '#EBECF6', 
          padding: 4, 
          borderRadius: 2, 
          textAlign: 'center' 
        }}
      >
        {userData.phone === prodId ? (
          // Seller
          <div>
            <Typography variant="h6" gutterBottom>
              Seller
            </Typography>
            {buyerPaid && !sellerConfirmed ? (
              <Box>
                <Typography>Buyer has paid!</Typography>
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={handleSellerPaymentReceived}
                  sx={{ mt: 2 }}
                >
                  Confirm Payment Received
                </Button>
              </Box>
            ) : (
              <Typography>Buyer will pay soon!</Typography>
            )}
            {sellerConfirmed && (
              <Typography>Payment received and confirmed!</Typography>
            )}
          </div>
        ) : (
          // Buyer
          <Box>
            <Typography variant="h6">Pay to seller: {product.upiNum || "8700641339"}</Typography>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleBuyerPaymentCompleted}
              sx={{ mt: 2 }}
            >
              Payment Completed
            </Button>
            <Button 
              variant="outlined" 
              color="secondary" 
              onClick={() => navigate(`/store/${userId}`)}
              sx={{ mt: 2 }}
            >
              Got the product
            </Button>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default Payment;
